import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import { fetchSchemaPolicy } from '@/slices/dictSlice';
import PermWrapper from '@/components/PermWrapper';
import { toText } from '..';
import Modal from './Modal';

function SchemaPolicy({ data, commonProps, fetchSchemaPolicy }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchSchemaPolicy();
  }, [fetchSchemaPolicy]);

  return (
    <>
      <Descriptions
        title='Schema 兼容策略'
        bordered
        actions={
          <PermWrapper resource='pulsar:topic:list:configUpdate'>
            <Button onClick={() => setVisible(true)} theme='default' variant='outline' size='small'>
              修改
            </Button>
          </PermWrapper>
        }
      >
        <Descriptions.Item label='兼容策略' value={toText(data.schemaCompatibilityStrategy)} />
      </Descriptions>
      <Modal
        visible={visible}
        detail={data}
        commonProps={commonProps}
        handleClose={() => setVisible(false)}
      />
    </>
  );
}

export default connect(
  (state) => ({
    data: state.topic.polices,
  }),
  {
    fetchSchemaPolicy,
  },
)(SchemaPolicy);
